import {api} from 'fast-sdk';
import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import * as app from 'store/slices/app';
import {
  generateColoredOrgName,
  generateRandomOrgName,
} from '../lib/name-generator';
import {prepareSubdomain} from '../lib/utils';

export function useTierOrgGenerator() {
  const environmentDomain = useSelector(app.selectors.getEnvironmentDomain);

  async function checkSubdomainAvailability(subdomain) {
    const {result} = await api.organization.checkDomainName(subdomain);
    return result;
  }

  async function generateUniqueOrgName(maxAttempts = 5) {
    let attempts = 0;

    while (attempts < maxAttempts) {
      const orgName =
        Math.random() > 0.5
          ? generateRandomOrgName()
          : generateColoredOrgName();

      const subdomain = prepareSubdomain(orgName, environmentDomain);

      const isAvailable = await checkSubdomainAvailability(subdomain);

      if (isAvailable) {
        return {
          orgName,
          subdomain,
          attempts: attempts + 1,
        };
      }

      attempts++;
    }

    let orgName = '';
    let subdomain = '';
    attempts = 0;

    while (attempts < maxAttempts) {
      orgName = generateRandomOrgName();
      subdomain = `${prepareSubdomain(orgName, environmentDomain)}-${Math.random().toString(36).substring(2, 8)}`;
      const isAvailable = await checkSubdomainAvailability(subdomain);
      if (isAvailable) {
        break;
      }
    }

    return {
      orgName,
      subdomain,
    };
  }

  const generateName = useCallback(async () => {
    try {
      const orgData = await generateUniqueOrgName();
      return orgData;
    } catch (error) {
      console.error('Error generating name:', error);
      throw error;
    }
  }, []);

  return {
    generateName,
  };
}
